import { createResponseSchema, ErrorSchema } from '@mint-sdk/api-core';
import { AdserverUrnEnum } from '@mint-sdk/api-integrations/compat';
import z from 'zod';

export const OmniTraffickingIntegrationsQueryParams = z.object({
  companyId: z.array(z.string()).nullish(),
  adServer: AdserverUrnEnum.nullish(),
});
export const OmniTraffickingAdformOAuthCallbackRequestSchema = z.object({
  name: z.string(),
  code: z.string(),
  integrationId: z.string().nullable(),
});

export const OmniTraffickingAdformOAuthCallbackResponseSchema =
  createResponseSchema(
    z.object({
      oauthFlowId: z.string(),
    }),
  );
export const OmniTraffickingAdformOAuthUrlResponseSchema = createResponseSchema(
  z.object({
    clientId: z.string(),
    redirectUri: z.string(),
    responseType: z.string(),
    state: z.string(),
    scope: z.string(),
  }),
);
export const OmniTraffickingDeleteResponseSchema = z.object({
  data: z
    .object({
      items: z.null(),
      message: z.string().nullable(),
      pageNumber: z.number().nullable(),
      itemsPerPage: z.number().nullable(),
      totalItems: z.number().nullable(),
      ordering: z.string().nullable(),
      additional: z.null(),
    })
    .nullable(),
  error: ErrorSchema.nullable(),
});

export const OmniTraffickingOAuthQuerySchema = z.object({
  oauthFlowId: z.string(),
});

export const OmniTraffickingCMOGetProfilesQuerySchema = z.object({
  oauthFlowId: z.string().nullable(),
  integrationId: z.string().nullable(),
});

export const OmniTraffickingCMOGetAdvertisersQuerySchema = z.object({
  profileId: z.string(),
  oauthFlowId: z.string().nullable(),
  integrationId: z.string().nullable(),
});

export const OmniTraffickingGetAdvertisers = createResponseSchema(
  z.object({
    id: z.string(),
    name: z.string(),
  }),
);
export const OmniTraffickingCMGetProfilesResponseSchema = createResponseSchema(
  z.object({
    id: z.string(),
    name: z.string(),
  }),
);
export const OmniTraffickingCMGetAdvertisersResponseSchema =
  createResponseSchema(
    z.object({
      id: z.string(),
      name: z.string(),
      floodlightConfigId: z.string(),
    }),
  );
export const OmniTraffickingAdformCreateRequestSchema = z.object({
  name: z.string(),
  oauthFlowId: z.string(),
  advertiser: z.object({
    id: z.string(),
    name: z.string(),
  }),
});
export const OmniTraffickingAdformUpdateRequestSchema = z.object({
  name: z.string(),
});
export const OmniTraffickingAppsFlyerCreateRequestSchema = z.object({
  name: z.string(),
  iosId: z.string(),
  androidId: z.string(),
  apiToken: z.string(),
});

export const OmniTraffickingAppsFlyerUpdateRequestSchema = z.object({
  name: z.string(),
  apiToken: z.string().nullable(),
});

export const OmniTraffickingCMOauthUrlQuerySchema = z.object({
  integrationId: z.string().nullable(),
});

export const OmniTraffickingCMOauthCallbackQuerySchema = z.object({
  oauthFlowId: z.string(),
  state: z.string(),
  code: z.string(),
  integrationId: z.string().nullable(),
});

export const OmniTraffickingCMOauthCallbackResponseSchema =
  createResponseSchema(
    z.object({
      reconnectState: z.string(),
    }),
  );
export const OmniTraffickingCMOauthUrlResponseSchema = createResponseSchema(
  z.object({
    authorizationUrl: z.string(),
    oauthFlowId: z.string(),
  }),
);
export const OmniTraffickingCMCreateRequestSchema = z.object({
  name: z.string(),
  profile: z.object({
    id: z.string(),
    name: z.string(),
  }),
  advertisers: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      floodlightConfigId: z.string(),
    }),
  ),
  isDv360Linked: z.boolean(),
  oauthFlowId: z.string(),
});
export const OmniTraffickingCMUpdateRequestSchema = z.object({
  name: z.string().nullable(),
  profile: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .nullable(),
  advertisers: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
        floodlightConfigId: z.string(),
      }),
    )
    .nullable(),
  isDv360Linked: z.boolean().nullable(),
});

export type OmniTraffickingAdformCreateRequestSchemaType = z.infer<
  typeof OmniTraffickingAdformCreateRequestSchema
>;
